/**
 * Shared Customer → Group dropdown empty-state helpers.
 *
 * Before customer: Group disabled → "Select a customer first"
 * Customer with groups: Group enabled → "Select a group"
 * Customer with no groups: Group disabled → "No groups available"
 */

export const CUSTOMER_DROPDOWN_SELECT_LABEL = 'Select a customer';
export const GROUP_DROPDOWN_SELECT_CUSTOMER_FIRST = 'Select a customer first';
export const GROUP_DROPDOWN_SELECT_A_GROUP = 'Select a group';
export const GROUP_DROPDOWN_NO_GROUPS_LABEL = 'No groups available';

/** @deprecated Use GROUP_DROPDOWN_NO_GROUPS_LABEL */
export const GROUP_DROPDOWN_ALL_LABEL = 'All';
/** @deprecated Use CUSTOMER_DROPDOWN_SELECT_LABEL */
export const GROUP_DROPDOWN_PLEASE_CHOOSE_LABEL = 'Please Choose';

/** True when a concrete customer is selected (not empty / "All"). */
export function hasConcreteCustomerSelected(
  customerValue: string | number | null | undefined
): boolean {
  if (customerValue == null) {
    return false;
  }
  const value = String(customerValue).trim();
  return value !== '' && value !== 'All';
}

/**
 * Empty-option / placeholder label for Group dropdowns.
 * @param groupsLoaded when false and a customer is selected, treat as still loading
 *        (show "Select a group", keep disabled) instead of "No groups available".
 */
export function getGroupDropdownEmptyLabel(
  hasCustomerSelected: boolean,
  groupsCount: number,
  groupsLoaded = true
): string {
  if (!hasCustomerSelected) {
    return GROUP_DROPDOWN_SELECT_CUSTOMER_FIRST;
  }
  if (!groupsLoaded) {
    return GROUP_DROPDOWN_SELECT_A_GROUP;
  }
  if (groupsCount === 0) {
    return GROUP_DROPDOWN_NO_GROUPS_LABEL;
  }
  return GROUP_DROPDOWN_SELECT_A_GROUP;
}

/** Group dropdown is disabled until a customer is selected, or when that customer has no groups. */
export function isGroupDropdownDisabled(
  hasCustomerSelected: boolean,
  groupsCount: number,
  groupsLoaded = true
): boolean {
  if (!hasCustomerSelected) {
    return true;
  }
  if (!groupsLoaded) {
    return true;
  }
  return groupsCount === 0;
}
